export default "__VITE_ASSET__BTAflHzw__"